module.exports = __webpack_public_path__ + "static/media/sqlite.53beafa3.png";